import {
  ArrowRight,
  ArrowUpRight,
  MapPin,
  X,
  ChevronRight,
} from "lucide-react";
import { ZONES, ZONE_BY_ID } from "../data/city";
import { useCity } from "../state/CityContext";
import { StatusPill } from "./Primitives";
export function ExplorePanel() {
  const { state, dispatch, current } = useCity();
  const place = state.selected ? ZONE_BY_ID[state.selected] : null;
  const condition = current.zones.find((z) => z.id === state.selected);
  return (
    <section
      className="mode-panel explore-panel"
      aria-label="Explore Lichfield"
    >
      <span className="eyebrow panel-kicker">
        <span className="section-number">01</span> EXPLORE / LICHFIELD
      </span>
      {place && condition ? (
        <div className="place-detail" key={place.id}>
          <div className="place-detail-top">
            <MapPin size={17} />
            <button
              className="icon-button"
              aria-label="Close selected place"
              onClick={() => dispatch({ type: "select", zone: null })}
            >
              <X size={16} />
            </button>
          </div>
          <h1>{place.name}</h1>
          <span className="mini-label">{place.type}</span>
          <p>{place.description}</p>
          <div className="place-coordinates">
            {place.coordinates[1].toFixed(5)}° N &nbsp;{" "}
            {Math.abs(place.coordinates[0]).toFixed(5)}° W
          </div>
          <div className="place-condition">
            <span>Simulated continuity</span>
            <strong>{Math.round(condition.continuity)}%</strong>
            <StatusPill severity={100 - condition.continuity} />
          </div>
          <div className="system-bars">
            {(["water", "transport", "power"] as const).map((s, i) => (
              <div key={s}>
                <span>
                  {["Water stress", "Mobility stress", "Energy stress"][i]}
                </span>
                <div>
                  <i style={{ width: `${condition[s]}%` }} />
                </div>
                <b>{Math.round(condition[s])}%</b>
              </div>
            ))}
          </div>
          <button
            className="primary-button"
            onClick={() => dispatch({ type: "mode", mode: "respond" })}
          >
            Manage this area <ArrowRight size={17} />
          </button>
          <button
            className="text-button"
            onClick={() =>
              dispatch({ type: "perspective", perspective: "resident" })
            }
          >
            See the resident perspective <ArrowUpRight size={14} />
          </button>
        </div>
      ) : (
        <div className="explore-intro">
          <h1>
            A city.
            <br />A thousand
            <br />
            <em>connections.</em>
          </h1>
          <p>
            Look closer. Lichfield is more than a collection of places. It’s a
            living network of systems, people and possibilities.
          </p>
          <button
            className="primary-button"
            onClick={() => dispatch({ type: "mode", mode: "simulate" })}
          >
            Change something. See what follows. <ArrowRight size={17} />
          </button>
        </div>
      )}
      <div className="places-heading">
        <span className="eyebrow">PLACES TO DISCOVER</span>
        <span className="mini-label">06 anchors</span>
      </div>
      <div className="place-list">
        {ZONES.map((z, i) => (
          <button
            key={z.id}
            className={state.selected === z.id ? "active" : ""}
            onClick={() => dispatch({ type: "select", zone: z.id })}
          >
            <span className="place-index">0{i + 1}</span>
            <span>{z.name}</span>
            <ChevronRight size={14} />
          </button>
        ))}
      </div>
      <div className="field-note">
        <span className="field-note-line" />
        <p>
          Real geography. Imagined possibilities.
          <br />
          Every scenario is an experiment.
        </p>
      </div>
    </section>
  );
}
